import { InfoFilled } from "@clockwise/icons";
import { Tooltip } from "@clockwise/web-commons/src/ui/tooltip";
import React from "react";

export const FixableConflictTooltip = () => {
  const tooltipText =
    "Fixable conflicts are events that Clockwise has found alternate free times for. When you schedule your meeting, Clockwise will help move the fixable conflicts to those new times.";
  return (
    <Tooltip placement="top" showArrow={false} body={tooltipText}>
      <InfoFilled className="cw-w-3.5 cw-h-3.5 cw-mt-[5px] cw-cursor-pointer cw-text-info-disabled cw-ml-1" />
    </Tooltip>
  );
};
